<template>
  <el-drawer v-model="visible" size="720px" title="返现计划详情" @closed="onClosed">
    <template v-if="detail">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="计划编号">{{ detail.id }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="statusTag(detail.status)" size="small">{{ statusLabel(detail.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="会员">
          {{ detail.nickname || '-' }}（{{ detail.mobile || detail.userId }}）
        </el-descriptions-item>
        <el-descriptions-item label="订单号">{{ detail.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="商品" :span="2">
          {{ detail.spuName }}（SPU:{{ detail.spuId }}）
        </el-descriptions-item>
        <el-descriptions-item label="件序号">
          {{ detail.pieceIndex }} / {{ detail.pieceCount || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="日比例">{{ formatRate(detail.dailyRate) }}</el-descriptions-item>
        <el-descriptions-item label="总额">￥{{ fenToYuan(detail.totalPrice || 0) }}</el-descriptions-item>
        <el-descriptions-item label="日额">￥{{ fenToYuan(detail.dailyPrice || 0) }}</el-descriptions-item>
        <el-descriptions-item label="已发">￥{{ fenToYuan(detail.grantedPrice || 0) }}</el-descriptions-item>
        <el-descriptions-item label="剩余">￥{{ fenToYuan(detail.remainPrice || 0) }}</el-descriptions-item>
        <el-descriptions-item label="人工暂停">
          <el-tag v-if="detail.adminPaused" type="warning" size="small">是</el-tag>
          <span v-else>否</span>
        </el-descriptions-item>
        <el-descriptions-item label="售后暂停">
          <el-tag v-if="detail.afterSalePaused" type="danger" size="small">是</el-tag>
          <span v-else>否</span>
        </el-descriptions-item>
        <el-descriptions-item label="首次可发日">{{ detail.firstGrantDate || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近发放日">{{ detail.lastGrantDate || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收货时间">{{ detail.receiveTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="关闭原因">{{ detail.closeReason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="mt-16px mb-8px font-medium">发放流水</div>
      <el-table :data="detail.grants || []" size="small" border>
        <el-table-column align="center" label="发放日" prop="grantDate" width="120" />
        <el-table-column align="center" label="金额" width="100">
          <template #default="{ row }">￥{{ fenToYuan(row.price || 0) }}</template>
        </el-table-column>
        <el-table-column align="center" label="钱包流水" prop="walletTransactionId" min-width="100" />
        <el-table-column align="center" label="幂等键" prop="bizId" min-width="140" />
        <el-table-column
          align="center"
          label="时间"
          prop="createTime"
          :formatter="dateFormatter"
          width="170"
        />
      </el-table>

      <div class="mt-16px mb-8px font-medium">操作日志</div>
      <el-table :data="detail.opLogs || []" size="small" border>
        <el-table-column align="center" label="类型" prop="opType" width="90">
          <template #default="{ row }">{{ opTypeLabel(row.opType) }}</template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="reason" min-width="140" />
        <el-table-column align="center" label="操作人" prop="operatorId" width="90" />
        <el-table-column
          align="center"
          label="时间"
          prop="createTime"
          :formatter="dateFormatter"
          width="170"
        />
      </el-table>
    </template>
  </el-drawer>
</template>

<script lang="ts" setup>
import { fenToYuan } from '@/utils'
import { dateFormatter } from '@/utils/formatTime'
import * as CashbackPlanApi from '@/api/mall/trade/cashback/plan'
import type { CashbackPlanVO } from '@/api/mall/trade/cashback/plan'

const visible = ref(false)
const detail = ref<CashbackPlanVO>()

const STATUS_OPTS = [
  { value: 1, label: '发放中', type: 'primary' },
  { value: 2, label: '已完成', type: 'success' },
  { value: 3, label: '已关闭', type: 'info' },
  { value: 4, label: '已作废', type: 'danger' }
]

const statusLabel = (s?: number) => STATUS_OPTS.find((o) => o.value === s)?.label || '-'
const statusTag = (s?: number) => (STATUS_OPTS.find((o) => o.value === s)?.type as any) || 'info'
const formatRate = (r?: number) => (r == null ? '-' : (r / 100).toFixed(2) + '%')
const opTypeLabel = (t?: string) =>
  ({ PAUSE: '暂停', RESUME: '恢复', VOID: '作废' } as Record<string, string>)[t || ''] || t || '-'

const open = async (id: number) => {
  detail.value = await CashbackPlanApi.getCashbackPlan(id)
  visible.value = true
}
const onClosed = () => {
  detail.value = undefined
}

defineExpose({ open })
</script>
